<div class="checkbox-container">
  <div class="input-container" [class.error]="errorMessage()" [formGroup]="form">
    <input type="checkbox" [name]="name()" [formControlName]="controlName()" />
    <label [for]="name()">
      <ng-content></ng-content>
    </label>
  </div>
  @if (errorMessage(); as _message) {
    <span class="error-message">{{ _message }}</span>
  }
</div>
